module.exports = __webpack_public_path__ + "img/work2021Intro.6df85507.png";